// Localização: frontend/src/components/Prontuario/Profissional/RH/FaltaFormModal.jsx (versão 1.0.0)
// Modal de formulário para registrar falta

import React, { useState } from 'react';
import { X } from 'lucide-react';
import { createFalta } from '../../../../api/api';

const FaltaFormModal = ({ isOpen, onClose, profissionalId, onSuccess }) => {
    const [formData, setFormData] = useState({
        data_falta: '',
        tipo_falta: 'nao_justificada',
        motivo: '',
        justificativa: '',
        horas_faltadas: '',
        status: 'pendente'
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            const dados = {
                ...formData,
                horas_faltadas: formData.horas_faltadas ? parseFloat(formData.horas_faltadas) : null
            };

            const response = await createFalta(profissionalId, dados);
            if (response.data.success) {
                onSuccess();
            } else {
                setError(response.data.message || 'Erro ao registrar falta.');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao registrar falta.');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
                    <h2 className="text-xl font-semibold text-gray-900">Registrar Falta</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="h-6 w-6" />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="p-6 space-y-4">
                    {error && (
                        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                            {error}
                        </div>
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Data da Falta *
                            </label>
                            <input
                                type="date"
                                required
                                value={formData.data_falta}
                                onChange={(e) => setFormData({ ...formData, data_falta: e.target.value })}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Tipo de Falta *
                            </label>
                            <select
                                required
                                value={formData.tipo_falta}
                                onChange={(e) => setFormData({ ...formData, tipo_falta: e.target.value })}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                            >
                                <option value="justificada">Justificada</option>
                                <option value="nao_justificada">Não Justificada</option>
                                <option value="atraso">Atraso</option>
                                <option value="saida_antecipada">Saída Antecipada</option>
                            </select>
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Motivo *
                        </label>
                        <input
                            type="text"
                            required
                            value={formData.motivo}
                            onChange={(e) => setFormData({ ...formData, motivo: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                            placeholder="Ex: Consulta médica"
                        />
                    </div>

                    {formData.tipo_falta === 'justificada' && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Justificativa
                            </label>
                            <textarea
                                value={formData.justificativa}
                                onChange={(e) => setFormData({ ...formData, justificativa: e.target.value })}
                                rows={3}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                                placeholder="Detalhes da justificativa..."
                            />
                        </div>
                    )}

                    {(formData.tipo_falta === 'atraso' || formData.tipo_falta === 'saida_antecipada') && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Horas Faltadas
                            </label>
                            <input
                                type="number"
                                step="0.5"
                                value={formData.horas_faltadas}
                                onChange={(e) => setFormData({ ...formData, horas_faltadas: e.target.value })}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                                placeholder="0.0"
                            />
                        </div>
                    )}

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Status
                        </label>
                        <select
                            value={formData.status}
                            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                        >
                            <option value="pendente">Pendente</option>
                            <option value="aprovada">Aprovada</option>
                            <option value="rejeitada">Rejeitada</option>
                        </select>
                    </div>

                    <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors disabled:opacity-50"
                        >
                            {loading ? 'Salvando...' : 'Salvar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default FaltaFormModal;

